/* eslint-disable @typescript-eslint/no-unused-vars */
import { log } from 'consoleManager';
import {
  NETWORK_URL_TYPE,
  HISTORY_NETWORK_CAPTURE,
  UNKNOWN_STATE,
  NETWORK_TYPE,
  GA_EVENTS_IGNORE_LIST,
} from 'src/utils/enum';

const gv2NetworksLogs = [];
let gaNetworksLogs = [];
let captureGaEventsInterval;

/**
 * capture Api log from browser Network (GV2)
 */
const initializeNetworkCaptureOnfetch = () => {
  try {
    const platformType = localStorage.getItem('GV_NETWORK_PLATFORM_TYPE');
    if (platformType === 'WEB') {
      captureWebGaEvents();
    }
    log('network capture start');
    const constantMock = window.fetch;
    window.fetch = function () {
      networkProxy(arguments);
      removeEventPanelId(arguments);
      return constantMock.apply(this, arguments);
    };
  } catch (error) {
    console.log(error);
  }
};

const removeEventPanelId = (argumentsData) => {
  const fetchArgArray = argumentsData;
  if (fetchArgArray && fetchArgArray.length >= 2) {
    const fetchUrl = argumentsData[0];
    const domain = new URL(fetchUrl);
    const URL_TO_INTERCEPT = [
      HISTORY_NETWORK_CAPTURE.GODAVARI_PREPROD,
      HISTORY_NETWORK_CAPTURE.GODAVARI_PROD,
      HISTORY_NETWORK_CAPTURE.GOOGLE_TV,
      HISTORY_NETWORK_CAPTURE.GOOGLE_TV2,
    ];
    if (URL_TO_INTERCEPT.includes(domain.hostname)) {
      if (argumentsData?.[1]?.body && isJsonString(argumentsData?.[1]?.body)) {
        const bodyPayLoad = JSON.parse(argumentsData?.[1]?.body);
        if (
          fetchUrl.indexOf(NETWORK_URL_TYPE.priority) != -1 ||
          fetchUrl.indexOf(NETWORK_URL_TYPE.google) != -1
        ) {
          if (typeof bodyPayLoad?.panel_event_id != 'undefined') {
            delete bodyPayLoad.panel_event_id;
            argumentsData[1].body = JSON.stringify(bodyPayLoad);
          }
        } else if (fetchUrl.indexOf(NETWORK_URL_TYPE.batched) != -1) {
          if (bodyPayLoad.length > 0) {
            for (let index = 0; index < bodyPayLoad.length; index++) {
              if (typeof bodyPayLoad[index]?.panel_event_id != 'undefined') {
                delete bodyPayLoad[index].panel_event_id;
              }
            }
            argumentsData[1].body = JSON.stringify(bodyPayLoad);
          }
        }
      }
    }
  }
};

const networkProxy = (argumentsData) => {
  const fetchArgArray = argumentsData;
  if (fetchArgArray && fetchArgArray.length >= 2) {
    const fetchUrl = argumentsData[0];
    const domain = new URL(fetchUrl);
    const URL_TO_INTERCEPT = [
      HISTORY_NETWORK_CAPTURE.GODAVARI_PREPROD,
      HISTORY_NETWORK_CAPTURE.GODAVARI_PROD,
      HISTORY_NETWORK_CAPTURE.GOOGLE_TV,
      HISTORY_NETWORK_CAPTURE.GOOGLE_TV2,
    ];
    if (URL_TO_INTERCEPT.includes(domain.hostname)) {
      // if (fetchUrl.indexOf(NETWORK_URL_TYPE.priority) != -1) {
      //   exportDataGV(argumentsData, NETWORK_TYPE.priority);
      // } else
      if (fetchUrl.indexOf(NETWORK_URL_TYPE.batched) != -1) {
        exportDataGV(argumentsData, NETWORK_TYPE.batched);
      } else if (fetchUrl.indexOf(NETWORK_URL_TYPE.google) != -1) {
        exportDataGA(argumentsData);
      }
    }
  }
};

function exportDataGV(argumentsData, networkType) {
  const urlName = argumentsData?.[0];
  const bodyPayLoad = JSON.parse(argumentsData?.[1]?.body);
  let apiName = UNKNOWN_STATE;
  if (NETWORK_TYPE.priority == networkType) {
    if (bodyPayLoad['event_name']) {
      apiName = bodyPayLoad['event_name'];
    }
    if (apiName != UNKNOWN_STATE) {
      saveNetworkLogs(NETWORK_TYPE.priority, {
        apiName: apiName,
        urlName: urlName,
        urlBody: bodyPayLoad ? bodyPayLoad : {},
        status: UNKNOWN_STATE,
      });
    }
  } else {
    if (bodyPayLoad.length > 0) {
      bodyPayLoad.forEach(function (objectData) {
        if (objectData['event_name']) {
          apiName = objectData['event_name'];
        }
        if (apiName != UNKNOWN_STATE) {
          saveNetworkLogs(NETWORK_TYPE.batched, {
            apiName: apiName,
            urlName: urlName,
            urlBody: objectData ? objectData : {},
            status: UNKNOWN_STATE,
          });
        }
      });
    }
  }
}

function exportDataGA(argumentsData) {
  const platformType = localStorage.getItem('GV_NETWORK_PLATFORM_TYPE');
  if (argumentsData?.[1]?.body && isJsonString(argumentsData?.[1]?.body)) {
    exportDataGATv(argumentsData);
  }
  // else {
  //   exportDataGAWeb(argumentsData);
  // }
}

function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    log(e);
    return false;
  }
  return true;
}

function exportDataGAWeb(argumentsData) {
  const params = argumentsData?.[0].split('?');
  const urlName = params?.[0];
  const urlBody = decodeURI(params?.[1])
    .split('&')
    .map((param) => param.split('='))
    .reduce((values, [key, value]) => {
      values[key] = value;
      return values;
    }, {});
  if (argumentsData?.[1]?.body) {
    decodeURI(argumentsData[1].body)
      .split('&')
      .map((param) => param.split('='))
      .reduce((values, [key, value]) => {
        values[key] = value;
        return values;
      }, {});
  }
  if (urlBody?.en) {
    saveNetworkLogs(NETWORK_TYPE.google, {
      apiName: urlBody?.en ? urlBody.en : UNKNOWN_STATE,
      urlName: urlName,
      urlBody: urlBody ? urlBody : {},
      status: UNKNOWN_STATE,
    });
  }
}

function exportDataGATv(argumentsData) {
  const urlName = argumentsData?.[0];
  const bodyPayLoad = JSON.parse(argumentsData?.[1]?.body);
  let apiName = UNKNOWN_STATE;
  if (bodyPayLoad?.events?.[0]?.name) {
    apiName = bodyPayLoad.events[0].name;
  }
  if (apiName != UNKNOWN_STATE) {
    saveNetworkLogs(NETWORK_TYPE.google, {
      apiName: apiName,
      urlName: urlName,
      urlBody: bodyPayLoad ? bodyPayLoad : {},
      status: UNKNOWN_STATE,
    });
  }
}

const saveNetworkLogs = (type, apiData = null) => {
  try {
    if (NETWORK_TYPE.google == type) {
      gaNetworksLogs.push(apiData);
    } else {
      gv2NetworksLogs.push(apiData);
    }
    window.gaNetworksLogs = gaNetworksLogs;
    window.gv2NetworksLogs = gv2NetworksLogs;
  } catch (error) {
    console.log(error);
  }
};

const downloadNetworkLogs = () => {
  downloadGvLogs();
  downloadGaLogs();
};

const downloadGvLogs = () => {
  const fileName = getDownloadFileName('gv2');
  const exportFileDefaultName = fileName + '.json';
  const dataStr = JSON.stringify(gv2NetworksLogs);
  const dataUri =
    'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
  const linkElement = document.createElement('a');
  linkElement.setAttribute('href', dataUri);
  linkElement.setAttribute('download', exportFileDefaultName);
  linkElement.click();
};

const downloadGaLogs = () => {
  const fileName = getDownloadFileName('ga');
  const exportFileDefaultName = fileName + '.json';
  const dataStr = JSON.stringify(gaNetworksLogs);
  const dataUri =
    'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
  const linkElement = document.createElement('a');
  linkElement.setAttribute('href', dataUri);
  linkElement.setAttribute('download', exportFileDefaultName);
  linkElement.click();
};

const getDownloadFileName = (fileType = 'gv2') => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  let month = currentDate.getMonth() + 1;
  let day = currentDate.getDate();
  let hour = currentDate.getHours();
  let minute = currentDate.getMinutes();
  let second = currentDate.getSeconds();
  month = month.toString().length == 1 ? '0' + month : month;
  day = day.toString().length == 1 ? '0' + day : day;
  hour = hour.toString().length == 1 ? '0' + hour : hour;
  minute = minute.toString().length == 1 ? '0' + minute : minute;
  second = second.toString().length == 1 ? '0' + second : second;
  const dateTime =
    year + '-' + month + '-' + day + '_' + hour + ':' + minute + ':' + second;
  const fileName = fileType + '_' + dateTime;
  return fileName;
};

const getGVNetworkLogs = () => {
  return gv2NetworksLogs;
};

const getGANetworkLogs = () => {
  return gaNetworksLogs;
};

const captureWebGaEvents = () => {
  clearInterval(captureGaEventsInterval);
  log('GA events Capture Start');
  captureGaEventsInterval = setInterval(() => {
    startCaptureGaEvents();
  }, 30000);
};

const startCaptureGaEvents = () => {
  if (typeof window.dataLayer === 'object' && window?.dataLayer?.length > 0) {
    let dataLayerObj = window?.dataLayer;
    gaNetworksLogs = [];
    let webGaEventData = [];
    for (let index = 0; index < dataLayerObj.length; index++) {
      if (
        typeof dataLayerObj?.[index]?.event != 'undefined' &&
        !GA_EVENTS_IGNORE_LIST.includes(dataLayerObj?.[index]?.event)
      ) {
        let eventData = {
          apiName: dataLayerObj?.[index]?.event
            ? dataLayerObj[index].event
            : UNKNOWN_STATE,
          urlName: UNKNOWN_STATE,
          urlBody: dataLayerObj[index] ? dataLayerObj[index] : {},
          status: UNKNOWN_STATE,
        };
        webGaEventData.push(eventData);
      }
    }

    gaNetworksLogs = webGaEventData;
    window.gaNetworksLogs = gaNetworksLogs;
    window.gv2NetworksLogs = gv2NetworksLogs;
  }
};

export {
  exportDataGAWeb,
  initializeNetworkCaptureOnfetch,
  getGVNetworkLogs,
  downloadNetworkLogs,
  saveNetworkLogs,
  networkProxy,
  getGANetworkLogs,
};
